@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/link.scss' as link;
@use 'src/global/mixins/feedback.scss' as fb;

c-bubble {
  display: block;
  height: 100%;
  hyphens: nones;
  -webkit-hyphens: none;
  $bbwidth: calc(100% - 24px);
  max-width: calc(100% - 24px);
  $timeoutBB: 100%;

  .bubble-container-with-feedback {
    @include fb.bubble-container-with-feedback;
  }

  section {
    padding: 1rem; // Has to adapt to global font size coming from BA CSS outside this component
    box-shadow: var.$message-screen-elements-box-shadow;
    box-sizing: border-box;

    a {
      @include link.link;
    }

    &.timeout {
      width: $timeoutBB;
      margin-top: 24px;
      border-radius: 20px;
      background: var.$text-color-light;
      border: solid 3px !important;
      border-color: crimson !important;
      color: var.$primary-color;
      text-align: center;
    }
    &.bot, &.loading {
      border-radius: var.$message-bubble-border-radius;
      background: var.$primary-color;
      color: var.$text-color-light;
    }
    &.user {
      border-radius: 20px 20px 0 20px;
      background: var.$text-color-light;
      color: var.$primary-color;
    }
    &.loading {
      span {
        font-size: 2rem;
        line-height: 0;
        animation-name: blink;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
      }
      span:nth-child(2) {
        animation-delay: 0.2s;
      }
      span:nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
